import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../utils/apiServices";

export const getSaleStatus = createAsyncThunk(
  "saleStatus/fetchSaleStatus",
  async () => {
    // setAuthorizationToken(true);
    const response = await getMethod(`/api/sale-status`);
    return response;
  }
);

const initialState = {
  loading: false,
  success: false,
  error: false,
  saleStatus: null,
};

const saleStatusSlice = createSlice({
  name: "saleStatus",
  initialState,
  // reducers: {
  //   isLoading: (state) => {
  //     state.loading = true;
  //     state.success = false;
  //     state.error = false;
  //   },
  //   isSuccess: (state, action) => {
  //     state.loading = false;
  //     state.success = true;
  //     state.error = false;
  //     state.saleStatus = action.payload;
  //   },
  //   isError: (state) => {
  //     state.loading = false;
  //     state.success = false;
  //     state.error = true;
  //   },
  // },

  extraReducers: (builder) => {
    builder.addCase(getSaleStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSaleStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.saleStatus = action.payload.data;
    });
    builder.addCase(getSaleStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

// export const { isLoading, isSuccess, isError } = saleStatusSlice.actions;

export default saleStatusSlice.reducer;

// export const getSaleStatus = () => async (dispatch) => {
//   try {
//     dispatch(isLoading);
//     const response = await getMethod(`/api/sale-status`);
//     dispatch(isSuccess(response?.data));
//   } catch (error) {
//     dispatch(isError);
//   }
// };
